import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IftaReportState } from '../types';
import { iftaReportsState } from './iftaReportsState';
import { Reports } from 'app/types/reports';

export const iftaReportsSlice = createSlice({
  name: 'iftaReports',
  initialState: iftaReportsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDrivers(state, action: PayloadAction<IftaReportState['drivers']>) {
      state.drivers = action.payload;
    },
    setReports(state, action: PayloadAction<Reports[]>) {
      state.reports = action.payload;
    },
    setHiddenReports(
      state,
      action: PayloadAction<IftaReportState['hiddenReports']>,
    ) {
      state.hiddenReports = action.payload;
    },
    setRequestPendingTo(
      state,
      action: PayloadAction<IftaReportState['isRequestPending']>,
    ) {
      state.isRequestPending = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: iftaReportsActions } = iftaReportsSlice;

/* ------- STATE SELECTORS ------- */
export const selectIftaReports = (state: RootState) => state.iftaReports;

export default iftaReportsSlice.reducer;
